export type ClassNameArgument =
  | string
  | { [key: string]: boolean }
  | null
  | undefined;

export const tw = (str: string | TemplateStringsArray) => str.toString();

export const classNames = (...args: ClassNameArgument[]): string => {
  const classes = args.flatMap((arg) => {
    if (!arg) {
      return "";
    }

    if (typeof arg === "string") {
      return arg;
    }

    return Object.entries(arg)
      .filter(([_, enabled]) => enabled)
      .map(([className]) => className);
  });

  return [...new Set(classes)].join(" ");
};
